import { useTranslation } from "react-i18next";
import { BASE_NAME } from "../../routes";

const LandingPage = () => {

    const translationPrefix = 'Index'
    const { t } = useTranslation('global');

    return (
        <section className="header relative pt-16 items-center flex h-screen max-h-860-px">
        <div className="container mx-auto items-center flex flex-wrap">
          <div className="w-full md:w-8/12 lg:w-6/12 xl:w-6/12 px-4">
            <div className="pt-32 md:pt-0">
              <div className="flex flex-row items-end">
                <img src={`${BASE_NAME}/img/logo.png`} alt='logo gema' className="w-1/2" />
              </div>
              {
                t(`${translationPrefix}.main_text`).replace(/\\n/g, '\n').split('\n').map((str, index) => {
                  return (
                    <p key={index} className="mt-4 ml-2 text-md leading-relaxed text-blueGray-500">
                      {str}
                    </p>
                  )
                })
              }              
            </div>
          </div>
        </div>
        <img
          className="absolute top-0 b-auto right-0 pt-16 sm:w-6/12 -mt-48 sm:mt-0 w-10/12 max-h-860-px"
          src={`${BASE_NAME}/img/pattern_nextjs.png`}
          alt="..."
        />
      </section>
    )
}

export default LandingPage;